import { useTrackStore } from '~/scenes/Build/scenes/FlowBuilder/stores/trackStore';

const BLOCK_EXECUTION_PREFIX = 'api-first:block-execution:';

export function apiFirstRouteTrackNameForMethod(methodId: string): string {
  return `api-first:${methodId}`;
}

export function resolveBlockExecutionComponentIdFromMethodId(
  methodId: string
): string | undefined {
  const trackName = apiFirstRouteTrackNameForMethod(methodId);
  const routeTrack = useTrackStore.getState().getTrack(trackName);
  return routeTrack?.componentIds?.[0];
}

export function buildBlockExecutionComponentId(methodId: string): string {
  return `${BLOCK_EXECUTION_PREFIX}${methodId}`;
}

export function expectedBlockExecutionLevelName(
  blockExecutionComponentId: string,
  track: 'onProcess' | 'onException'
): string {
  const suffix =
    track === 'onException' ? 'onExceptionTrack' : 'onProcessTrack';
  return `${blockExecutionComponentId}-${suffix}`;
}

export function resolveMethodIdFromBlockExecutionComponentId(
  blockExecutionComponentId: string | null | undefined
): string | undefined {
  if (!blockExecutionComponentId?.trim()) {
    return undefined;
  }
  const { tracks } = useTrackStore.getState();
  if (!tracks) {
    return undefined;
  }
  const match = Array.from(tracks).find(
    ([name, t]) =>
      name.startsWith('api-first:') &&
      t.componentIds?.[0] === blockExecutionComponentId
  );
  return match ? match[0].slice('api-first:'.length) : undefined;
}

export function getBlockExecutionIdFromLevelName(
  levelName: string | undefined
): string | null {
  if (!levelName) {
    return null;
  }
  if (levelName.endsWith('-onProcessTrack')) {
    return levelName.slice(0, -'-onProcessTrack'.length);
  }
  if (levelName.endsWith('-onExceptionTrack')) {
    return levelName.slice(0, -'-onExceptionTrack'.length);
  }
  return null;
}

/** @deprecated Prefer getBlockExecutionIdFromLevelName; block id is not always methodId. */
export function getMethodIdFromBlockExecutionLevelName(
  levelName: string | undefined
): string | null {
  const blockId = getBlockExecutionIdFromLevelName(levelName);
  if (!blockId?.startsWith(BLOCK_EXECUTION_PREFIX)) {
    return null;
  }
  return blockId.slice(BLOCK_EXECUTION_PREFIX.length);
}

export function isLevelOnExceptionTrack(
  levelName: string | undefined
): boolean {
  return Boolean(levelName?.endsWith('-onExceptionTrack'));
}
